import React, { Component } from "react";
import ReactDOM from "react-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withFormik } from "formik";
import * as Yup from "yup";
import _ from "lodash";

import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import InputLabel from "@material-ui/core/InputLabel";
import LinearProgress from "@material-ui/core/LinearProgress";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

import AddIcon from "@material-ui/icons/Add";
import ClearIcon from "@material-ui/icons/Clear";

//component
import ContentWrapper from "../../containers/ContentWrapper";
import AdminWrapper from "../../containers/AdminWrapper";
import AddStaffDialog from "../Dialogs/AddStaffDialog";
import ClientStaffSection from "./ClientStaffSection";
import ClientLanguageSection from "./ClientLanguageSection";
import ClientServicesSection from "./ClientServicesSection";
import AddServiceDialog from "../Dialogs/AddServiceDialog";
import AddLanguageDialog from "../Dialogs/AddLanguageDialog";

//redux constant
import * as shootTypes from "../../redux/constants/ShootsActionTypes";
//redux actions
import * as dialogActions from "../../redux/actions/dialogactions";
import ConfirmationDialog from "../Dialogs/ConfirmationDialog";
//services
import accountService from "../../services/accountsService";
import shootService from "../../services/shootService";

class CreateShoot extends Component {
  constructor(props) {
    super(props);
    let edit = this.props.match.params.id ? true : false;
    this.state = {
      validateCalled: false,
      staffs: [
        // {
        //   firstname: "Leanne",
        //   email: "leanne.friday@sample.com",
        //   lastname: "Friday",
        //   position: "Frontdesk",
        //   id: "0691ea4a-acb5-4a20-a7cf-08c5ae62864c"
        // },
        // {
        //   firstname: "Latosha",
        //   email: "latosha.segalla@sample.com",
        //   lastname: "Segalla",
        //   position: "Hygienist",
        //   id: "08931dca-6ffc-4b6f-999f-bdf4ed4794e3"
        // },
        // {
        //   firstname: "Gena",
        //   email: "gena.maggart@sample.com",
        //   lastname: "Maggart",
        //   position: "Hygienst",
        //   id: "25bc85a1-bc63-4b6e-be0f-dc951112be3b"
        // },
        // {
        //   firstname: "Marianne",
        //   email: "marianne.colley@sample.com",
        //   lastname: "Colley",
        //   position: "Hygienist",
        //   id: "a8c83b34-d99c-4e46-bab8-2e2989d0b7b3"
        // },
        // {
        //   firstname: "Jung",
        //   email: "jung.lockley@sample.com",
        //   lastname: "Lockley",
        //   position: "Dentist",
        //   id: "d474bb57-40db-4c0d-b15b-a54d30e3edfa"
        // }
      ],
      languages: [],
      services: [
        // "Dental Crowns",
        // "Dental Hygiene",
        // "Dentures",
        // "Flouride Treatment"
      ],
      edit,
      shooterList: [],

      addStaffDialog: false,
      addLanguageDialog: false,
      addServiceDialog: false,
      saving: false,

      categoryLabelWidth: 0,
      companyLabelWidth: 0
    };
  }

  async componentDidMount() {
    this.setState({
      // categoryLabelWidth: ReactDOM.findDOMNode(this.categoryRef).offsetWidth,
      companyLabelWidth: ReactDOM.findDOMNode(this.companyRef).offsetWidth
    });
    const accounts = await accountService.getAccounts({
      params: {
        type: "User"
      }
    });
    this.setState({ shooterList: accounts });
    //structure the data so that we are ready to get the data to the api
    //to get the shoot details we need the client name and the the shoot date
  }

  componentDidUpdate(prevProps) {
    if (prevProps.confirmDialog && !this.props.confirmDialog) {
      console.log("Modal closed!");
      console.log(prevProps.confirmDialog, this.props.confirmDialog);
      //have a switch to determine what action should we take, but if we only have one action
      //there is no need to have a switch .
      if (this.props.confirmChoice) {
        switch (this.props.confirmAction) {
          case shootTypes.SHOOTS_SAVE_SHOOT:
            console.log("saving shoot");
            this.saveShoot();
            break;
          default:
            break;
        }
      }
    }
  }

  addStaff = () => this.setState({ addStaffDialog: !this.state.addStaffDialog });

  addLanguage = () => this.setState({ addLanguageDialog: !this.state.addLanguageDialog });

  addService = () => this.setState({ addServiceDialog: !this.state.addServiceDialog });

  handleChange = name => e => {
    let state = this.state;
    state[name] = e.target.value;
    this.setState(state);
  };

  //give the components one functions so they can run it
  /*
  pass a function to the dialog component that accepts
  a value argument which is a object of the element that will
  be added to the array.
  {
    name: '',//staffs || languages || services
    value: {
      firstname: "example",
      lastname: "example",
      position: "example"
    }
  }
  */
  updateState = object => {
    let newState;
    if (typeof object.value === "object") {
      //staffs in state
      let state = this.state;
      let staffs = state[object.name];
      staffs = staffs.concat(object.value);

      newState = _.assign({}, this.state, { staffs });
    } else if (typeof object.value === "string") {
      let state = this.state[object.name];
      let tempArray = state.concat(object.value);
      let tempObject = {};
      tempObject[object.name] = tempArray;
      newState = _.assign({}, tempObject);
    } else {
      new Error("The argument type is not acceptable it must be object or string");
    }

    this.setState(newState, () => {
      let value;
      let objectName;
      if (object.name === "staffs") {
        value = !this.state.addStaffDialog;
        objectName = "addStaffDialog";
      } else if (object.name === "services") {
        value = !this.state.addServiceDialog;
        objectName = "addServiceDialog";
      } else if (object.name === "languages") {
        value = !this.state.addLanguageDialog;
        objectName = "addLanguageDialog";
      } else {
        new Error(`${object.name} is not an acceptable argument!`);
      }
      this.setState({ [objectName]: value });
    });
  };

  removeItem = (name, index) => {
    let state = this.state;
    state[name].splice(index, 1);
    this.setState(state);
  };

  handleToggle = name => {
    const currentIndex = this.state.languages.indexOf(name);
    const newChecked = [...this.state.languages];
    console.log("clear", name, currentIndex, newChecked);
    if (currentIndex === -1) {
      newChecked.push(name);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    this.setState({
      languages: newChecked
    });
  };

  confirmSaveShoot = async () => {
    this.setState({ validateCalled: true });
    await this.props.validateForm();
    if (this.props.isValid) {
      this.props.dialogActions.openConfirmDialog("Are you sure?", "You are about to save the shoot.", shootTypes.SHOOTS_SAVE_SHOOT, "No", "Yes");
    }
  };

  saveShoot = async () => {
    //dispatch an action so that we can save the shoot
    //in the saga that will be created.
    // console.log("save the shoot!");
    try {
      this.setState({ saving: true });
      if (this.props.isValid) {
        let { values } = this.props;
        await shootService.addShoot({
          clinic: values.name,
          address: values.address,
          company: "Freelance",
          date: new Date(values.selectedDate).getTime(),
          language: this.state.languages,
          staff: this.state.staffs,
          service: this.state.services,
          cognitoId: values.shooter,
          hasInterview: values.hasInterview
        });

        this.props.history.push("/shoots");
      }
      this.setState({ saving: false });
    } catch (err) {
      this.setState({ saving: false });
      console.log(err);
    }
  };

  handleDateChange = date => {
    this.setState({ selectedDate: date });
  };

  hasInterviewChange = (e, checked) => {
    this.setState({
      hasInterview: checked
    });
  };

  render() {
    const { validateCalled } = this.state;
    const { handleChange, handleBlur, errors, values, touched } = this.props;

    console.log("this.state, this.props", this.state, this.props);

    return (
      <AdminWrapper {...this.props}>
        <ContentWrapper hasHeader title="Create Shoot" hasPadding>
          <Toolbar variant="dense" style={{ padding: "10px 5px" }} disableGutters={true}>
            <Tooltip title="Cancel">
              <Button onClick={this.props.history.goBack} aria-label="cancel" color="primary" variant="outlined">
                Cancel
              </Button>
            </Tooltip>
            <div style={{ flexGrow: 1 }} />
            <Tooltip title="Create Shoot">
              <Button
                onClick={this.confirmSaveShoot}
                color="primary"
                aria-label="Add"
                style={{ marginLeft: "5px", boxShadow: "none" }}
                variant="contained"
              >
                Save Shoot
              </Button>
            </Tooltip>
          </Toolbar>
          {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              variant="outlined"
              color="primary"
              onClick={this.props.history.goBack}
            >
              Back
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={this.confirmSaveShoot}
            >
              Save Shoot
              {this.state.saving ? (
                <CircularProgress
                  color="#fff"
                  size={12} 
                  style={{ marginLeft: 5 }}
                />
              ) : null}
            </Button>
          </div> */}

          <div style={{ display: "flex", justifyContent: "center" }}>
            <Grid item xd={12} sm={10} md={6}>
              <Typography component="span" variant="h6" color="inherit">
                Shoot Details
              </Typography>
              {this.state.saving && <LinearProgress color="primary" style={{ height: 2, marginTop: 20 }} />}
              <Paper style={this.state.saving ? { padding: 24 } : { padding: 24, marginTop: 20 }}>
                <Typography component="span" variant="subtitle2" color="inherit" gutterBottom>
                  Please enter the details of the shoot.
                </Typography>
                <TextField
                  autoComplete="off"
                  id="name"
                  helperText={(touched.name || validateCalled) && errors.name}
                  error={(touched.name || validateCalled) && errors.name}
                  value={values.name}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  label="Client name"
                  margin="normal"
                  style={{ width: "100%" }}
                  variant="outlined"
                  disabled={this.state.saving}
                />
                <TextField
                  autoComplete="off"
                  value={this.state.address}
                  id="address"
                  helperText={(touched.address || validateCalled) && errors.address}
                  error={(touched.address || validateCalled) && errors.address}
                  value={values.address}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  label="Address"
                  margin="normal"
                  style={{ width: "100%" }}
                  variant="outlined"
                  disabled={this.state.saving}
                />
                <FormControl
                  variant="outlined"
                  style={{ width: "100%" }}
                  margin="normal"
                  error={(touched.shooter || validateCalled) && errors.shooter}
                >
                  <InputLabel
                    ref={ref => {
                      this.companyRef = ReactDOM.findDOMNode(ref);
                    }}
                    htmlFor="outlined-age-native-simple"
                  >
                    Shooter
                  </InputLabel>
                  <Select
                    native
                    value={values.shooter}
                    input={
                      <OutlinedInput
                        id="shooter"
                        labelWidth={this.state.companyLabelWidth}
                        style={{ width: "100%" }}
                        error={(touched.shooter || validateCalled) && errors.shooter}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    }
                    disabled={this.state.saving}
                  >
                    <option value="" />
                    {this.state.shooterList.map((shooter, index) => {
                      const { Attributes } = shooter;
                      return (
                        <option
                          key={Attributes.email}
                          value={shooter.Username}
                        >{`${Attributes.given_name} ${Attributes.family_name} — ${Attributes.email}`}</option>
                      );
                    })}
                  </Select>
                  <FormHelperText error={(touched.shooter || validateCalled) && errors.shooter}>
                    {(touched.shooter || validateCalled) && errors.shooter}
                  </FormHelperText>
                </FormControl>
                <TextField
                  id="selectedDate"
                  label="Shoot Schedule"
                  type="datetime-local"
                  variant="outlined"
                  defaultValue={values.selectedDate}
                  InputLabelProps={{
                    shrink: true
                  }}
                  style={{ width: "100%", margin: "16px 0 8px 0" }}
                  onChange={handleChange}
                  disabled={this.state.saving}
                />
                <FormControlLabel
                  control={
                    <Switch id="hasInterview" checked={values.hasInterview} color="primary" onChange={handleChange} disabled={values.saving} />
                  }
                  label={values.hasInterview ? "With interview" : "Without interview"}
                  labelPlacement="end"
                />
              </Paper>

              <ClientLanguageSection
                openDialog={this.addLanguage}
                data={this.state.languages}
                handleToggle={this.handleToggle}
                disabled={this.state.saving}
              />

              <ClientStaffSection openDialog={this.addStaff} data={this.state.staffs} removeItem={this.removeItem} disabled={this.state.saving} />

              <ClientServicesSection
                openDialog={this.addService}
                data={this.state.services}
                removeItem={this.removeItem}
                disabled={this.state.saving}
              />
            </Grid>
          </div>

          <AddStaffDialog
            open={this.state.addStaffDialog}
            handleClose={this.addStaff}
            addStaffToState={this.updateState}
            removeItem={this.removeItem}
          />

          <AddServiceDialog
            open={this.state.addServiceDialog}
            handleClose={this.addService}
            addServiceToState={this.updateState}
            removeItem={this.removeItem}
          />

          <AddLanguageDialog
            open={this.state.addLanguageDialog}
            handleClose={this.addLanguage}
            addLanguageToState={this.updateState}
            removeItem={this.removeItem}
          />
        </ContentWrapper>
        <ConfirmationDialog />
      </AdminWrapper>
    );
  }
}

const CreateShootWithFormik = withFormik({
  mapPropsToValues: () => {
    const dateToday = new Date();
    return {
      name: "",
      address: "",
      company: "Freelance",
      hasInterview: false,
      selectedDate: `${dateToday.getFullYear()}-${dateToday.getMonth() + 1 >= 10 ? dateToday.getMonth() + 1 : "0" + (dateToday.getMonth() + 1)}-${
        dateToday.getDate() >= 10 ? dateToday.getDate() : "0" + dateToday.getDate()
      }T${dateToday.getHours() >= 10 ? dateToday.getHours() : "0" + dateToday.getHours()}:${
        dateToday.getMinutes() >= 10 ? dateToday.getMinutes() : "0" + dateToday.getMinutes()
      }`,
      shooter: ""
    };
  },
  validationSchema: Yup.object().shape({
    name: Yup.string().required("Client name is required"),
    address: Yup.string().required("Client address is required!"),
    selectedDate: Yup.string().required("Date of the shoot is required!"),
    shooter: Yup.string().required("Please assign a shooter.")
  }),
  validateOnChange: true
})(CreateShoot);

const mapStateToProps = state => {
  return {
    confirmDialog: state.dialog.confirm.open,
    confirmAction: state.dialog.confirm.action,
    confirmChoice: state.dialog.confirm.confirmed
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dialogActions: bindActionCreators(dialogActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateShootWithFormik);
